export { default } from "./Locale.js";
